import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { filter, fromEvent, pipe } from 'rxjs';

@Directive({
  selector: '[scrollObserver]',
})
export class ScrollObserverDirective {
  @HostListener('window:scroll', ['$event']) handleScroll(event: any) {
    let container: HTMLElement = this.el.nativeElement;
    if (window.scrollY > 44) {
      this.renderer.addClass(container, 'stickToHeader');
    } else {
      this.renderer.removeClass(container, 'stickToHeader');
    }
  }
  constructor(private el: ElementRef, private renderer: Renderer2) {}
}
